import { useViewport } from 'contexts/viewport';
import { PageContext } from 'pages/People/PageProvider';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Button,
    Checkbox,
    Divider,
    Drawer,
    IconButton,
    ScrollableTableMobileSortFilters,
    Stack,
    styled,
    Text,
} from 'shell/components';

const FilterDrawer = ({ columns, sortState, handleSetSortState }) => {
    const { device } = useViewport();
    const { t } = useTranslation();

    const { filters, setFilters, resetFilters } = useContext(PageContext);

    const onClose = () => {
        setFilters((current) => ({ ...current, open: false }));
    };

    const toggleRoles = (role) => {
        setFilters((current) => ({
            ...current,
            roles: current.roles.includes(role) ? current.roles.filter((s) => s !== role) : [...current.roles, role],
        }));
    };

    return (
        <Drawer anchor={'left'} device={device === 'desktop' ? 'tablet' : device} open={filters.open} onClose={onClose}>
            <Stack spacing={3}>
                <IconButton
                    sx={{ alignSelf: 'flex-end' }}
                    aria-label={'close'}
                    kind={'exit'}
                    size={'medium'}
                    variant={'square'}
                    onClick={onClose}
                />

                <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                    <Text component={'h1'} variant={'h6'} weight={'semibold'}>
                        {t('controls.sort-by', 'Sort By')}
                    </Text>
                    <Button variant={'borderless'} onClick={resetFilters}>
                        {t('controls.reset-all', 'Reset All')}
                    </Button>
                </Stack>
                <ScrollableTableMobileSortFilters
                    columns={columns}
                    sortState={sortState}
                    handleSetSortState={handleSetSortState}
                />
                <Divider />
                <Text component={'h1'} variant={'h6'} weight={'semibold'}>
                    {t('controls.filters', 'Filters')}
                </Text>
                <Stack spacing={2}>
                    <Text color={'light'} variant={'p1'} weight={'semibold'}>
                        {t('ui.role', 'Role')}
                    </Text>
                    <CustomStack>
                        <CustomCheckbox
                            checked={filters.roles.includes('staff')}
                            label={t('ui.staff', 'Staff')}
                            labelPlacement={'start'}
                            onChange={() => toggleRoles('staff')}
                        />
                        <CustomCheckbox
                            checked={filters.roles.includes('student')}
                            label={t('ui.student', 'Student')}
                            labelPlacement={'start'}
                            onChange={() => toggleRoles('student')}
                        />
                    </CustomStack>
                </Stack>
            </Stack>
        </Drawer>
    );
};

const CustomStack = styled(Stack)(({ theme }) => ({
    paddingLeft: theme.spacing(4),
}));

const CustomCheckbox = styled(Checkbox)(({ theme }) => ({
    justifyContent: 'space-between',
    '& > .MuiTypography-root': {
        color: theme.palette.ensightful.neutral[700],
    },
}));

export default FilterDrawer;
